import React from "react";

import { Badge } from "./base/badge";
import { CopyButton } from "./copy-button";

export function Tags({
  tags,
  copyable,
}: {
  tags: string[];
  copyable?: boolean;
}) {
  return (
    <span className="inline-flex flex-wrap gap-1">
      {tags?.map((tag) => (
        <Badge key={tag} variant="secondary">
          {tag}
          {copyable && (
            <CopyButton value={tag} variant="tertiary" size="xs" iconOnly />
          )}
        </Badge>
      ))}
    </span>
  );
}
